<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 研学团建</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="error" class="elalert">
        1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）<br />
        2.报名成功后，可到上导航条下载专区下载《主题研学、团建手册》<br />
      </el-alert>

      <div class="left_and_right_container">
        <div class="container_center">
          <el-form
            :model="formData"
            ref="ruleForm"
            :rules="rules"
            label-width="100px"
            class="demo-ruleForm"
          >
            <div class="apply_info_title">申报信息</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="主题研学名称">
                  {{ formData.saiqu_name }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位名称" prop="danwei">
                  <el-input
                    type="text"
                    placeholder="请输入单位名称"
                    v-model="formData.danwei"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="到达时间" prop="get_date">
                  <el-date-picker
                    v-model="formData.get_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人姓名" prop="ldname">
                  <el-input
                    type="text"
                    placeholder="请输入姓名"
                    v-model="formData.ldname"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系手机" prop="phone">
                  <el-input
                    type="text"
                    placeholder="请输入手机"
                    v-model="formData.phone"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="特殊诉求" prop="note">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 5 }"
                    placeholder="本次团队活动是否需要增加民族餐？病人餐或宵夜？是否需要残疾椅租赁车辆？是否需要大床房或亲子房？是否有外宾等，请如实填写。"
                    v-model="formData.note"
                    class="inputSizeClass"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-show="formData.id > 0">
              <el-col :span="12">
                <el-form-item label="上传人员表" prop="xlsx">
                  <FileUploader
                    :accept="'.xlsx'"
                    :fileList="formData.xlsx"
                    :limit="1"
                    :beforeRead="importExcel"
                    :name="'xlsx'"
                  ></FileUploader>
                  <!-- importExcel -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="" prop="note"> </el-form-item>
              </el-col>
            </el-row>

            <el-row
              :gutter="20"
              v-show="formData.id > 0 && userListForm.list.length > 0"
            >
              <el-col :span="12">
                <el-form-item label="食宿类型" prop="service_id">
                  <el-select v-model="formData.service_id" placeholder="请选择">
                    <el-option
                      :key="sindex"
                      v-for="(service, sindex) in service_options"
                      :label="service.name + '(' + service.price + '元)'"
                      :value="service.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务套餐" prop="note">
                  <el-select
                    v-model="formData.trip_ids"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      :key="sindex"
                      v-for="(service, sindex) in trip_options"
                      :label="
                        service.name +
                        '(' +
                        service.price +
                        '元/' +
                        (service.price_type == 1 ? '次' : '人') +
                        ')' +
                        service.days +
                        '天'
                      "
                      :value="service.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div
              v-show="formData.id > 0 && userListForm.list.length > 0"
              class="apply_info_title"
            >
              费用信息
            </div>
            <el-row
              :gutter="20"
              v-show="formData.id > 0 && userListForm.list.length > 0"
            >
              <el-col :span="12">
                <el-form-item label="天数">
                  {{ total_days }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="日期" v-show="end_date && total_days">
                  {{ formData.get_date }} 至 {{ end_date }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              v-show="formData.id > 0 && userListForm.list.length > 0"
            >
              <el-col :span="12">
                <el-form-item label="人数统计">
                  总计：{{ member.total }} （男{{ member.m }}，女{{
                    member.f
                  }}）
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="费用">
                  {{ price.total }}
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-show="formData.id > 0 && userListForm.list.length > 0">
              <el-form
                :rules="userListForm.rules"
                :model="userListForm"
                ref="userListForm"
              >
                <el-table :data="userListForm.list" style="width: 100%">
                  <el-table-column prop="name" label="姓名" width="180">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.name }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.name'"
                          :rules="userListForm.rules.name"
                        >
                          <el-input
                            v-model="scope.row.name"
                            placeholder="请输入姓名"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" label="身份证" width="180">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.num }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.num'"
                          :rules="userListForm.rules.num"
                        >
                          <el-input
                            v-model="scope.row.num"
                            placeholder="请输入身份证号"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sex" label="性别">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.sex }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.sex'"
                          :rules="userListForm.rules.sex"
                        >
                          <el-select
                            v-model="scope.row.sex"
                            placeholder="请选择"
                          >
                            <el-option label="男" value="男"> </el-option>
                            <el-option label="女" value="女"> </el-option>
                          </el-select>
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" label="手机">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.phone }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.phone'"
                          :rules="userListForm.rules.phone"
                        >
                          <el-input
                            v-model="scope.row.phone"
                            placeholder="请输入手机号"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="subject" label="专业">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.subject }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.subject'"
                          :rules="userListForm.rules.subject"
                        >
                          <el-input
                            v-model="scope.row.subject"
                            placeholder="请输入专业"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="clazz" label="班级">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.clazz }}
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.clazz'"
                          :rules="userListForm.rules.clazz"
                        >
                          <el-input
                            v-model="scope.row.clazz"
                            placeholder="请输入班级"
                          />
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="false" prop="sex" label="服务套餐">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        {{ scope.row.service_name }} ({{
                          scope.row.service_price
                        }}元)
                      </p>
                      <p v-else>
                        <el-form-item
                          :prop="'list.' + scope.$index + '.service_id'"
                          :rules="userListForm.rules.service_id"
                        >
                          <el-select
                            v-model="scope.row.service_id"
                            @change="onServiceChange($event, scope.row)"
                            placeholder="请选择"
                          >
                            <el-option
                              :key="sindex"
                              v-for="(service, sindex) in service_options"
                              :label="
                                service.name + '(' + service.price + '元)'
                              "
                              :value="service.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="action" label="操作">
                    <template slot-scope="scope">
                      <p v-if="!scope.row.edit">
                        <el-button @click="onUserEdit(scope.row)"
                          >编辑</el-button
                        >
                        <el-popconfirm
                          title="这是一段内容确定删除吗？"
                          @confirm="onUserRemove(scope.row, scope.$index)"
                        >
                          <el-button slot="reference">删除</el-button>
                        </el-popconfirm>
                      </p>
                      <p v-else>
                        <el-button @click="onUserSave(scope.row)"
                          >保存</el-button
                        >
                        <el-popconfirm
                          title="这是一段内容确定删除吗？"
                          @confirm="onUserRemove(scope.row, scope.$index)"
                        >
                          <el-button slot="reference">删除</el-button>
                        </el-popconfirm>
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
              <div style="margin-top: 20px">
                <el-button @click="onUserAdd()">新增用户</el-button>
              </div>
            </el-row>

            <el-row>
              <el-col class="btn_position_class">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >提交</el-button
                >
                <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <ElPayDialog
      :show="payDialogShow"
      scene="yanxue"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
    <OrderDetailDialog
      :fieldArr="fieldArr"
      :memberArr="memberArr"
      :dialogShow="orderDetailDialogShow"
      @orderDetailDialogConfirm="orderDetailDialogConfirm"
      @orderDetailDialogCancel="orderDetailDialogCancel"
    />
  </div>
</template>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import NewsListItem from "@/components/listItem/NewsListItem";
import ElPayDialog from "@/components/ElPayDialog";
import { CountDown } from "vant";
import FileUploader from "@/components/picker/FileUploader.vue";
import { dateFormat } from "../../../utils/date";
import XLSX from "xlsx";
import OrderDetailDialog from "@/components/OrderDetailDialog";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      areaOptions: [],
      payDialogShow: false,
      orderIds: [],
      saiqu_id: this.$route.query.saiqu_id,
      rules: {
        danwei: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        get_date: [{ required: true, message: "请选择日期", trigger: "blur" }],
        ldname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        num: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
      },
      formData: {
        id: 0,
        saiqu_name: "",
        danwei: "",
        phone: "",
        note: "",
        ldname: "",
        areas: [],
        xlsx: [],
        service_id: "",
        trip_ids: [],
        get_date: null,
        extra_course_id: "",
        grade: "",
      },
      userListForm: {
        rules: {
          sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
          service_id: [
            { required: true, message: "请选择套餐", trigger: "blur" },
          ],
          clazz: [{ required: true, message: "请输入班级", trigger: "blur" }],
          subject: [{ required: true, message: "请输入专业", trigger: "blur" }],
          name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            {
              min: 2,
              max: 20,
              message: "长度在 2 到 50 个字符",
              trigger: "blur",
            },
          ],
          num: [
            { required: true, message: "请输入身份证号", trigger: "blur" },
            { validator: validator.idCard, trigger: "blur" },
          ],
          phone: [
            { required: true, message: "请输入手机号", trigger: "blur" },
            { validator: validator.phone, trigger: "blur" },
          ],
        },
        list: [],
      },
      gradeOptions: [
        {
          id: 1,
          name: "一级",
        },
        {
          id: 2,
          name: "二级",
        },
        {
          id: 3,
          name: "三级",
        },
        {
          id: 4,
          name: "四级",
        },
        {
          id: 5,
          name: "五级",
        },
        {
          id: 6,
          name: "六级",
        },
        {
          id: 7,
          name: "七级",
        },
        {
          id: 8,
          name: "八级",
        },
      ],
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
      courseOptions: [],
      service_options: [],
      trip_options: [],
      orderDetailDialogShow: false,
    };
  },
  components: {
    NewsListItem,
    ElPayDialog,
    FileUploader,
    OrderDetailDialog,
  },
  computed: {
    end_date() {
      let that = this;
      let date = that.formData.get_date;
      if (!date) {
        return "";
      }
      date = date.replace(/-/g, "/"); //必须把日期'-'转为'/'
      var timestamp = new Date(date).getTime();
      // return ;
      return dateFormat(timestamp + this.total_days * 3600 * 24 * 1000);
      return timestamp;
    },
    total_days() {
      let that = this;
      let days = 0;
      that.trip_options.map((item) => {
        if (that.formData.trip_ids.indexOf(item.id) > -1) {
          days += item.days;
        }
      });

      return days;
    },
    member() {
      let that = this;
      let [total, f, m] = [0, 0, 0];
      that.userListForm.list.map((item) => {
        if (item["sex"] == "男") {
          m++;
        } else {
          f++;
        }
        total++;
      });

      return {
        total,
        f,
        m,
      };
    },
    price() {
      let total = 0;
      let that = this;
      let shisu_price = 0;
      let trip_price = 0;
      that.service_options.map((item) => {
        if (that.formData.service_id == item.id) {
          shisu_price =
            item.price * that.userListForm.list.length * that.total_days;
        }
      });

      that.trip_options.map((item) => {
        if (that.formData.trip_ids.indexOf(item.id) > -1) {
          if (item.price_type == 1) {
            trip_price += parseFloat(item.price);
          } else {
            trip_price +=
              parseFloat(item.price) * that.userListForm.list.length;
          }
        }
      });
      total = shisu_price + trip_price;
      return {
        total,
      };
    },
    //处理弹窗内容
    memberArr() {
      var targetMemberArr = [];
      this.userListForm.list.some((item) => {
        var third_tempar = [];
        for (let key in item) {
          var temp_arr = {};
          switch (key) {
            case "name":
              temp_arr["name"] = "姓名";
              temp_arr["value"] = item[key];
              break;
            case "sex":
              temp_arr["name"] = "性别";
              temp_arr["value"] = item[key];
              break;
            case "phone":
              temp_arr["name"] = "手机";
              temp_arr["value"] = item[key];
              break;
            case "subject":
              temp_arr["name"] = "专业";
              temp_arr["value"] = item[key];
              break;
            case "num":
              temp_arr["name"] = "身份证号";
              temp_arr["value"] = item[key];
              break;
            case "clazz":
              temp_arr["name"] = "班级";
              temp_arr["value"] = item[key];
              break;
          }
          if (temp_arr.name) {
            third_tempar.push(temp_arr);
          }
        }
        if (third_tempar.length > 0) {
          targetMemberArr.push(third_tempar);
        }
      });
      return targetMemberArr;
    },
    //处理弹窗内容
    fieldArr() {
      var fieldArr_temp = [];
      var target_obj = {};
      for (let key in this.formData) {
        target_obj = {};
        switch (key) {
          case "danwei":
            target_obj.name = "单位";
            target_obj.value = this.formData["danwei"];
            break;
          case "get_date":
            target_obj.name = "到达时间";
            target_obj.value = this.formData["get_date"];
            break;
          case "ldname":
            target_obj.name = "联系人姓名";
            target_obj.value = this.formData["ldname"];
            break;
          case "phone":
            target_obj.name = "联系手机";
            target_obj.value = this.formData["phone"];
            break;
          case "note":
            target_obj.name = "特殊诉求";
            target_obj.value = this.formData["note"];
            break;
          case "service_id":
            target_obj.name = "食宿类型";
            this.service_options.some((item) => {
              if (item.id == this.formData["service_id"]) {
                target_obj.value = item.name + "(" + item.price + "元)";
              }
            });
            break;
          case "trip_ids":
            target_obj.name = "服务套餐";
            target_obj.value=""
            this.trip_options.some((item) => {
              this.formData["trip_ids"].some((ele) => {
                if (parseInt(ele) == parseInt(item.id)) {
                  target_obj.value +=
                    " [" +
                    item.name +
                    "(" +
                    item.price +
                    "元/" +
                    (item.price_type == 1 ? "次" : "人") +
                    ")" +
                    item.days +
                    "天" +
                    "] ";
                }
              });
            });
            break;
        }
        if (target_obj.name) {
          fieldArr_temp.push(target_obj);
        }
      } //for  结束
      target_obj = {};
      target_obj.name = "天数";
      target_obj.value = this.total_days;
      fieldArr_temp.push(target_obj);

      target_obj = {};
      target_obj.name = "日期";
      target_obj.value = this.formData.get_date + "至" + this.end_date;
      fieldArr_temp.push(target_obj);

      target_obj = {};
      target_obj.name = "人数统计";
      target_obj.value =
        "总计：" +
        this.member.total +
        "(男" +
        this.member.m +
        ",女" +
        this.member.f +
        ")";
      fieldArr_temp.push(target_obj);

      target_obj = {};
      target_obj.name = "费用";
      target_obj.value = this.price.total;
      fieldArr_temp.push(target_obj);

      return fieldArr_temp;
    },
  },
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id || 0;
    this.fetch();
    document.title = "研学团建申报";
    // that.getAreaOptions();
  },
  methods: {
    orderDetailDialogConfirm() {
      this.ordersaveFun();
    },
    orderDetailDialogCancel() {
      this.orderDetailDialogShow = false;
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (r) => {
        that.areaOptions = r.data;
      });
    },
    getGradeOptions() {
      let that = this;
      that.$api.post(
        "/api/kaoji/extraCourseOptions",
        {
          grade: that.formData.grade,
        },
        (r) => {
          that.courseOptions = r.data;
        }
      );
    },
    onGradeChange() {
      let that = this;
      that.formData.extra_course_id = "";
      that.getGradeOptions();
    },
    onServiceChange(val, row) {
      let selected = this.service_options.filter((item) => {
        return item.id == val;
      });
      if (selected.length == 0) {
        return;
      }
      row.service_name = selected[0].name;
      row.service_price = selected[0].price;
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/yanxue/step1Detail",
        {
          saiqu_id: that.saiqu_id,
          id: that.formData.id,
        },
        (res) => {
          res.data.trip_ids = res.data.trip_ids.map((item) => {
            return parseInt(item);
          });
          that.formData = Object.assign(that.formData, res.data);
          that.service_options = res.data.service_options;
          that.trip_options = res.data.trip_options;
          that.userListForm.list = res.data.member_list.map((member) => {
            that.$set(member, "edit", false);
            return member;
          });

          console.log("Dialog");
          if (res.data.haveNoDone) {
            that
              .$confirm("建议您选择继续未完成的报名", "您有未完成的报名", {
                confirmButtonText: "继续未完成的报名",
                cancelButtonText: "重新报名",
                type: "warning",
              })
              .then(() => {
                that.jumToOld();
              })
              .catch(() => {});
          }
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            that.$message.error(res.msg);
          }
        }
      );
    },
    onUserAdd() {
      let that = this;
      that.userListForm.list.push({
        name: "",
        phone: "",
        sex: "",
        num: "",
        service_id: "",
        edit: true,
      });
    },
    onUserSave(row) {
      const that = this;
      that.$refs["userListForm"].validate((valid) => {
        if (valid) {
          row.edit = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onUserEdit(row) {
      row.edit = true;
    },
    onUserRemove(row, index) {
      this.userListForm.list.splice(index, 1);
    },
    ordersaveFun() {
      var that = this;
      that.$api.post(
        "/api/yanxue/ordersave",
        {
          id: that.formData.id,
        },
        (r2) => {
          that.orderIds = r2.data.ids;
          that.payDialogShow = true;
        },
        (r2) => {
          that.$message.error(r.msg);
        }
      );
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formData.list = JSON.stringify(that.userListForm.list);
          // that.formData.get_date = that.formData.get_date_m.format('YYYY-MM-DD');
          that.$api.post("/api/yanxue/baoming", that.formData, (r) => {
            that.$message.success("保存成功");

            that.formData.id = r.data.id;
            if (r.data.memberstatus != 1) {
              this.orderDetailDialogShow = true;
            }

            // that.$router.push({name:'KaojiExame',query:{
            //   kaoji_id:r.data.id
            //   }})
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    onPayError() {
      let that = this;
      console.log("onPayError 支付失败");
      that.payDialogShow = false;

      that.$toast("支付失败");

      rbLink(
        {
          name: "yanxueApplyList",
        },
        "replace"
      );
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      that.payDialogShow = false;

      appEvent({
        name: "saiApplyDetailReload",
        query: {},
      });

      setTimeout(function () {
        rbLink(
          {
            name: "yanxueApplyList",
            query: {},
          },
          "replace"
        );
      }, 500);
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;

      setTimeout(function () {
        rbLink(
          {
            name: "yanxueApplyList",
          },
          "replace"
        );
      }, 500);
    },

    jumToOld() {
      rbLink(
        {
          name: "yanxueApplyList",
        },
        "replace"
      );
    },
    importExcel(file) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      let that = this;
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlc", "xlm", "xls", "xlt", "xlw", "csv"].some(
        (item) => item === types
      );
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          console.log("this.xlsxJson", this.xlsxJson);
          that.userListForm.list = [];
          that.xlsxJson[0].sheet.map((item) => {
            that.userListForm.list.push({
              name: item["姓名"],
              phone: item["手机"],
              sex: item["性别"],
              num: item["身份证号"],
              subject: item["专业"],
              clazz: item["班级"],
              service_id: "",
              edit: false,
            });
          });
          // xlsxJson就是解析出来的json数据,数据格式如下
          // [
          //   {
          //     sheetName: sheet1
          //     sheet: sheetData
          //   }
          // ]
        }
      });
      return true;
    },
    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },
  },
};
</script>
<style scoped lang="scss">
.apply_info_title {
  font-size: 20px;
  font-weight: bold;
}
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  // height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    .container_left_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 88px 0 0 0;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border: none;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        margin: 16px 0;
        height: 20px;
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        display: flex;
        align-items: center;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: default;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 1240px;
    min-height: 560px;
    background: #ffffff;
    margin-bottom: 30px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding-top: 24px;
    padding: 88px 0 30px 29px;
    box-sizing: border-box;
    .inputSizeClass {
      width: 240px;
      height: 40px;
      border-radius: 4px;
    }
    .btn_position_class {
      text-align: center;
      margin: 55px 0 0 0;
      box-sizing: border-box;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
        font-size: 14px;
      }
    }
  }

  .container_right {
    width: 296px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// YanxueApplyStep1.vue?d77ef758